import { isNPageOrHigherPageView, isValidContentType, isValidSection, isValidTag, isIOS9, isPaidContent, isPreview, } from '@frontend/web/components/SignInGate/displayRule';
import { hasUserDismissedGate } from '../dismissGate';
const canShow = (CAPI, isSignedIn, currentTest) => !isSignedIn &&
    !hasUserDismissedGate(currentTest.variant, currentTest.name) &&
    isNPageOrHigherPageView(3) &&
    isValidContentType(CAPI) &&
    isValidSection(CAPI) &&
    isValidTag(CAPI) &&
    !isPaidContent(CAPI) &&
    !isPreview(CAPI) &&
    !isIOS9();
export const signInGateComponent = {
    canShow,
};
